<template>
      <div  class="" style="background: #1e1e2d;">
        <v-row no-gutters class="fill-height">
          <!-- Aside with background image -->
          <v-col cols="12" md="6" class="d-none d-md-flex align-center justify-center" style="background: #23233c;">
            <v-img :src="backgroundImage" contain max-width="200" />
          </v-col>
          <!-- Login Form -->
          <v-col cols="12" md="6" class="d-flex align-center justify-center">
            <v-card class="elevation-12 pa-8" max-width="400" width="100%" color="#23233c">
              <v-card-title class="headline font-weight-bold white--text justify-center">
                Bem vindo ao Painel VivaTicket
              </v-card-title>
              <v-form ref="loginForm" v-model="valid" @submit.prevent="onSubmitLogin">
                <v-text-field dark v-model="form.login" :rules="loginRules" label="Login" outlined dense color="primary"
                  class="mt-6" prepend-inner-icon="mdi-account" required />
                <v-text-field dark v-model="form.password" :rules="passwordRules" label="Senha" outlined dense
                  color="primary" class="mt-4" prepend-inner-icon="mdi-lock" :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"
                  autocomplete="off" required />
                <v-btn :loading="loading" color="primary" class="mt-6" block large type="submit">
                  Entrar
                </v-btn>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/store/auth.module";
import Swal from "sweetalert2";

export default {
  name: "login",
  data() {
    return {
      form: {
        login: "",
        password: ""
      },
      valid: false,
      loading: false,
      showPassword: false,
      loginRules: [
        v => !!v || "Login é obrigatório"
      ],
      passwordRules: [
        v => !!v || "Senha é obrigatória"
      ]
    };
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    ...mapGetters(["currentUser"]),
    backgroundImage() {
      return process.env.BASE_URL + "media/logos/Logor.png";
    }
  },
  methods: {
    async onSubmitLogin() {
      const form = this.$refs.loginForm;
      if (form && !form.validate()) return;

      this.$store.dispatch(LOGOUT);
      this.loading = true;
      this.$store
        .dispatch(LOGIN, this.form)
        .then(() => this.$router.push({ name: "dashboard" }))
        .catch(() => {
          Swal.fire({
            title: "Dados incorretos!",
            text: "Confira suas credenciais e tente novamente.",
            icon: "error",
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
